// src/components/SiteLayout.tsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import AppNavbar from './Navbar';
import Footer from './Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../App.scss';
import '../i18n';

const SiteLayout: React.FC = () => {
  const goToHash = (hash: string) => {
    // Navigate to the landing page and let it handle smooth scrolling
    window.location.assign(`/${hash ? '#' + hash : ''}`);
  };

  return (
    <div>
      <AppNavbar
        scrollToHome={() => goToHash('home')}
        scrollToAbout={() => goToHash('about')}
        scrollToServices={() => goToHash('services')}
        scrollToContact={() => goToHash('contact')}
        scrollToDownload={() => goToHash('download')}
        scrollToFAQ={() => goToHash('faq')}
      />
      <div className="app-container">
        <Outlet />
        <Footer />
      </div>
    </div>
  );
};

export default SiteLayout;
